
import './style.scss';

import { Box, Grid } from '@mui/material';
import { useNavigationContext } from '../../contexts/NavigationContext';


const Content = () => {
    const { selectedNavigationLink } = useNavigationContext();

    return (
        <>
            <Box component={Grid} container className='content-admin'>
                <selectedNavigationLink.Component {...selectedNavigationLink} />
            </Box>
        </>
    );
}


export default Content;